/************************** BD CUSTOM LABEL SCRIPTS **********************/
// RECYCLINTIME -- replace entire file
function initProductLabelsJS() {
  // console.log('initProductLabelsJS')
  window.updateLabels = null;
    
  (function($) {
    Selectize.define('preorder', function(options) {
      const self = this;
      const setup = self.setup;
      this.setup = function() {
        setup.apply(self, arguments);
  
        // Intercept default handlers
        self.$dropdown.off('mousedown click', '[data-selectable]').on('mousedown click', '[data-selectable]', function(e) {
          if ($(this).hasClass('disabled')) {
            callPreOrderModal(
              $(this).data('product-name'),
              $(this).data('product-id'),
              $(this).data('variant-name'),
              $(this).data('variant-id')
            );
            return false;
          }
          return self.onOptionSelect.apply(self, arguments);
        });
      }
    });
  
    Selectize.define('araki-icons', function(options) {
      const self = this;
      const setup = self.setup;
      const open = self.open;
      this.setup = function() {
        setup.apply(self, arguments);
        // Intercept default handlers
        self.$dropdown.off('mousedown click', '[data-selectable]').on('mousedown', '[data-selectable]', function(e) {
          if ($(this).data('value') !== 'label_araki') return self.onOptionSelect.apply(self, arguments);
          self.$dropdown.find('.is_author').toggle();
          $(this).find('.arrow').toggleClass('ico-chevron-up').toggleClass('ico-chevron-down');
          return false;
        });
      }
      this.open = () => {
        self.$dropdown.find('.is_author').hide();
        self.$dropdown.find('[data-value="label_araki"] .arrow').removeClass('ico-chevron-up').addClass('ico-chevron-down');
        open.apply(self, arguments);
      }
    });
  
    var $ = jQuery = $;
    const isLabel = $('[data-label-product]').length > 0
    let isBuildBundle = false;
    let bundleSize = 0;
  
    const arakiIcons = ['araki-drop-icon', 'araki-eye-icon', 'araki-hearts-icon', 'araki-mushroom-icon', 'araki-rings-icon', 'araki-sun-icon'];
    const stdIcons = ['5PM-icon', '6PM-icon', '7PM-icon', 'choice-icon', 'heart-icon', 'pills-icon', 'sun-icon', 'rainbow-icon', 'lips-icon', 'jewelry-icon', 'liquid-icon', 'arctic-icon', 'pacific-icon', 'atlantic-icon', 'sage-icon', 'pine-icon', 'eucalyptus-icon', 'eye-icon', 'leaf-icon'];
    const isArakiIcon = (label) => arakiIcons.includes(label);
    const isIcon = (label) => [...stdIcons, ...arakiIcons].includes(label?.trim());
    const isGoldenHour = (label) => ['5PM', '6PM', '7PM'].includes(label);
    const isForPreorder = (label) => [].includes(label);
    window.isCustomImage = isCustomImage
    window.isIcon = isIcon
    window.outOfStockAraki = {
      "Charcoal":   ['araki-drop-icon', 'araki-eye-icon', 'araki-hearts-icon', 'araki-mushroom-icon', 'araki-rings-icon', 'araki-sun-icon'],
      "Petal":      [                   'araki-eye-icon', 'araki-hearts-icon',                        'araki-rings-icon', 'araki-sun-icon'],
      "Lavender":   [                   'araki-eye-icon', 'araki-hearts-icon',                        'araki-rings-icon', 'araki-sun-icon'],
      "Sand":       ['araki-drop-icon', 'araki-eye-icon', 'araki-hearts-icon', 'araki-mushroom-icon', 'araki-rings-icon', 'araki-sun-icon'],
      "Terracotta": ['araki-drop-icon', 'araki-eye-icon', 'araki-hearts-icon', 'araki-mushroom-icon', 'araki-rings-icon', 'araki-sun-icon'],
      "Pacific":    ['araki-drop-icon', 'araki-eye-icon',                                             'araki-rings-icon', 'araki-sun-icon'],
      "Eucalyptus": ['araki-drop-icon', 'araki-eye-icon', 'araki-hearts-icon', 'araki-mushroom-icon', 'araki-rings-icon', 'araki-sun-icon'],
      "5PM": arakiIcons,
      "6PM": arakiIcons,
      "7PM": arakiIcons,
    };
    
    // window.outOfStockAraki = {};
    const colorType = "color-option";
    const giftCardAmountType = "gift-card-amount";
    const labelType = "label-value";
    window.updateLabels = _updateLabels;
  
    if ($('.page-content, .quick-shop').hasClass('build-your-2-type')) {
      isBuildBundle = true;
      bundleSize = 2;
    } else if ($('html, .quick-shop').hasClass('page-build_your_3_tiles')) {
      isBuildBundle = true;
      bundleSize = 3;
    
    
    } else if (
          $('html, .quick-shop').hasClass('page-the_originals_-_set_of_2') 
      ||  $('html, .quick-shop').hasClass('page-the-132-set-of-2')
      ||  $('html').hasClass('page-flex-set-of-2')
    ) {
      // NEWBY2
      console.log('bundle size is 2');
      isBuildBundle = true;
      bundleSize = 2;

    } else if (
      $('html, .quick-shop').hasClass('page-the_originals_-_set_of_3') 
      ||  $('html').hasClass('page-the_originals_-_set_of_3')
      ||  $('html').hasClass('page-the_gradients_bundle_-_set_of_3_original')
      || $('html, .quick-shop').hasClass('page-the_gradients_bundle_-_set_of_3_original') 
      ||  $('html').hasClass('page-the_gradients_bundle_-_set_of_3_flex')
      || $('html, .quick-shop').hasClass('page-the_gradients_bundle_-_set_of_3_flex') 
      || $('html, .quick-shop').hasClass('page-the-132-set-of-3')
      || $('html, .quick-shop').hasClass('page-build-your-3')
    ) {
      // NEWBY4
      console.log('bundle size is 3');
      isBuildBundle = true;
      bundleSize = 3;
    } else if (
      $('html, .quick-shop').hasClass('page-the_originals_-_set_of_9') 
      ||  $('html').hasClass('page-the_originals_-_set_of_9')
      || $('html, .quick-shop').hasClass('page-the-132-set-of-9')
      || $('html, .quick-shop').hasClass('page-build-your-9') 
      ||  $('html').hasClass('page-the_gradients_bundle_-_set_of_9_original')
      || $('html, .quick-shop').hasClass('page-the_gradients_bundle_-_set_of_9_original') 
      ||  $('html').hasClass('page-the_gradients_bundle_-_set_of_9_flex')
      || $('html, .quick-shop').hasClass('page-the_gradients_bundle_-_set_of_9_flex') 
      

    ) {
      console.log('bundle size is 9');
      isBuildBundle = true;
      bundleSize = 9;

    // BFCM23
    } else if (
      $('html, .quick-shop').hasClass('page-the_originals_-_set_of_5') 
      ||  $('html').hasClass('page-the_originals_-_set_of_5')
      || $('html, .quick-shop').hasClass('page-the-132-set-of-5')
      || $('html, .quick-shop').hasClass('page-build-your-5') 
      ||  $('html').hasClass('page-a_moment_in_neutral_bundle_-_set_of_5_original')
      || $('html, .quick-shop').hasClass('page-a_moment_in_neutral_bundle_-_set_of_5_original') 
      ||  $('html').hasClass('page-a_moment_in_neutral_bundle_-_set_of_5_flex')
      || $('html, .quick-shop').hasClass('page-a_moment_in_neutral_bundle_-_set_of_5_flex') 

    ) {
      console.log('bundle size is 5');
      isBuildBundle = true;
      bundleSize = 5;
    
    } else if (
      $('html, .quick-shop').hasClass('page-the_originals_-_set_of_4') 
      ||  $('html').hasClass('page-the_originals_-_set_of_4')
      || $('html, .quick-shop').hasClass('page-the-132-set-of-4')
      || $('html, .quick-shop').hasClass('page-build-your-4') 
      ||  $('html').hasClass('page-paint_the_year_pink_bundle_-_set_of_4_original')
      || $('html, .quick-shop').hasClass('page-paint_the_year_pink_bundle_-_set_of_4_original') 
    ) {
      console.log('bundle size is 4');
      isBuildBundle = true;
      bundleSize = 4;
    
    } else if (
      $('html, .quick-shop').hasClass('page-the_originals_-_set_of_8') 
      ||  $('html').hasClass('page-the_originals_-_set_of_8')
      || $('html, .quick-shop').hasClass('page-the-132-set-of-8')
      || $('html, .quick-shop').hasClass('page-build-your-8') 
      ||  $('html').hasClass('page-paint_the_year_pink_bundle_-_set_of_8_original')
      || $('html, .quick-shop').hasClass('page-paint_the_year_pink_bundle_-_set_of_8_original') 
    ) {
      console.log('bundle size is 8');
      isBuildBundle = true;
      bundleSize = 8;
    } else if (
      $('html, .quick-shop').hasClass('page-the_flex_tile_(set_of_4)') 
      || $('html, .quick-shop').hasClass('page-the_flex_132_(medium)_-_set_of_4')
      || $('html, .quick-shop').hasClass('page-the-132-set-of-4')
      || $('html, .quick-shop').hasClass('page-build-your-4') 
      ||  $('html').hasClass('page-paint_the_year_pink_bundle_-_set_of_4_flex')
      || $('html, .quick-shop').hasClass('page-paint_the_year_pink_bundle_-_set_of_4_flex') 

      ) {
      isBuildBundle = true;
      bundleSize = 4;
    } else if (
      $('html, .quick-shop').hasClass('page-the_flex_tile_(set_of_8)') 
      || $('html, .quick-shop').hasClass('page-the_flex_132_(medium)_-_set_of_8')
      || $('html, .quick-shop').hasClass('page-the-132-set-of-8')
      || $('html, .quick-shop').hasClass('page-build-your-8') 
      ||  $('html').hasClass('page-paint_the_year_pink_bundle_-_set_of_8_flex')
      || $('html, .quick-shop').hasClass('page-paint_the_year_pink_bundle_-_set_of_8_flex') 

      ) {
      isBuildBundle = true;
      bundleSize = 8;
    } else if (
      // LANDINGPAGES2024
      $('html, .quick-shop').hasClass('page-the_originals_-_set_of_6') 
      || $('html').hasClass('page-the_original_tile_-_set_of_6')
      ||  $('html').hasClass('page-the_originals_special_edition')
      || $('html, .quick-shop').hasClass('page-build-your-6')
      || $('html, .quick-shop').hasClass('flex-6-v2')
    ) {
      isBuildBundle = true;
      bundleSize = 6;
    } else  if ($('html, .quick-shop').hasClass('page-build_your_9_tiles')
    ) {
      isBuildBundle = true;
      bundleSize = 9;
    } else if (
      $('html, .quick-shop').hasClass('page-the_originals_-_set_of_12') 
      || $('html, .quick-shop').hasClass('page-the_originals_-_set_of_12_tiles')
      || $('html, .quick-shop').hasClass('page-original_12')
      ) {
      isBuildBundle = true;
      bundleSize = 12;
    } else if ($('html, .quick-shop').hasClass('page-corporate_gifts')
    ) {
      isBuildBundle = true;
      bundleSize = 18;
    }else if (
      // LANDINGPAGES2024
      $('html, .quick-shop').hasClass('page-the_flex_tile_(set_of_7)') 
      || $('html, .quick-shop').hasClass('page-the_flex_132_(medium)_-_set_of_7')
      || $('html, .quick-shop').hasClass('flex-7-v2')
      ) {
      isBuildBundle = true;
      bundleSize = 7;
    }
    if(isBuildBundle) {
      const labelArray = [...Array(bundleSize).keys()].map(elem => `<span class="label-${elem+1}"></span>`).join('');
      const labelsMain = `<div class="build-your-${bundleSize}-labels-main">${labelArray}</div>`;
      $($('.product-image-main')[0]).append(labelsMain);
    }
    if(isLabel) {
      const labelsMain = '<div class="extra-label-labels-main"><span class="label"></span></div>';
      $($('.variant-image-wrapper')[0]).append(labelsMain);
    }

    // SELECTIZE - INITIALIZE LABELS
      initializeLabelsObject = {
        plugins: ['araki-icons', starterLabelSelectizeBaSPlugin],
        delimiter: ',',
        persist: false,
        create: false,
        form: 'test',
        sortField: [{
          field: 'name',
          direction: 'asc'
        }],
        searchField: ['value'],
        maxItems: 1,
        hideSelected: false,
        openOnFocus: true,
        create: function(input) {
          return {
            value: input,
            text: input,
            className: starterLabelSelectizeUserCreatedTagClass
          }
        },
        onInitialize: function() {
          if (this.$input.data('type') !== labelType) this.$control_input.prop('readonly','readonly');
          this.$control_input.parent().addClass('selectize-search-icon');
        },
        onClear: function() {
            $('.selected-items-list').empty();
            setMainImgLabels(this.$input, '')
        },
        onChange: function (value) {
          const elem = this.$input[0];
          const selectedOption = $(elem).find('option:selected').val();
          const select = $(elem).closest('select');
          window.corporateOnFormUpdate && window.corporateOnFormUpdate()

          const selects = $('.product-single__meta').find('select.selectized:not([data-type="color-option"])').toArray();
          const allCapsulesFilled = selects.every(elem => $(elem).val().trim() !== '')
          if (allCapsulesFilled) {
            el = $('.gift-card-with-product .expand-trigger')
            const wrapper = el.closest('.expand-wrapper');
            if (wrapper.hasClass('disabled')) {
              wrapper.removeClass('disabled')
              el.addClass('active');
              el.next().slideDown()
            }
          }

      
          if (select.data('type') === colorType) {
            // showExpectedToShipWarning($(this))
            if (value === 'Custom color') {
              $(elem).closest('.label-block').find('.custom-color-container').show()
              if (isValidMOQ && !isValidMOQ().color) {
                $('.js-modal-open-moq-error-color').click()
                
                const lastColor = this.currentResults.items.at(-1).id
                this.setValue(this.prevColor || lastColor);
              }
              return
            } else {
              $(elem).closest('.label-block').find('.custom-color-container').hide()
            }
            const productIndex = select.data('product-index');
            const values = Object.keys($(this)[0].options);
            const index = values.indexOf(selectedOption);
            const colorIdx = colorNames.indexOf(selectedOption.trim());
            const color = labelColors[colorIdx];
            const colorName = selectedOption.trim();

            this.prevColor = value
          
            // label img
            $(`.hex-container-${productIndex}`).find('.product-label-image').removeClass('active');
            // LABELPREVIEW-UPDATES
            $($(`.hex-container-${productIndex}`).find(`.product-label-image.${colorName}`)).addClass('active');
            
            //replaces this -->
            // $($(`.hex-container-${productIndex}`).find('.product-label-image')[colorIdx]).addClass('active');

            // label text color
            $(`.hex-container-${productIndex}`).find('.hex-graphics text').css('fill', color);
            // bundle overlay capsules
            if (isBuildBundle) {
              
              const productHandle = $(".page-content").attr('data-product-handle')
              if (isBuildYour(productHandle) || isLabelBuild(productHandle)) {
                // NEWBY4
                typeParam = (() => {
                  if (
                    productHandle === 'the-132-set-of-7' 
                    || productHandle === 'the-132-set-of-7-2'
                    || productHandle === 'the-132-set-of-7-fp' 
                    || productHandle === 'the-132-set-of-7-parcel'
                    || productHandle === 'the-132-set-of-6'
                    || productHandle === 'the-132-set-of-2'
                    || productHandle === 'the-132-set-of-3'
                    || productHandle === 'the-132-set-of-5' 
                    || productHandle === 'the-132-set-of-9' 
                    || productHandle === 'the-132-set-of-8' 
                    || productHandle === 'the-132-set-of-4'
                    || productHandle === 'the-132-set-of-4-sm'
                    || productHandle === 'the-132-set-of-3-sm'
                  ) return 'type=the-132-build&'
                  return isBuildYour(productHandle) ? 'type=build&' : 'type=label-bundle&'
                })()
                let imagesArray = $('.imageFromService').attr('data-boxes').split(',');
                imagesArray[productIndex - 1] = bundleColorValues.indexOf(selectedOption) + 1;
                $('.imageFromService').attr('data-boxes', imagesArray.join(','))

                // LANDINGPAGES2024 -- here is where the image gets updated every time a color is selected
                //image_service_url = 'https://cadenceco-label-service.herokuapp.com'
                // $('.imageFromService').attr('src', `https://cadenceco-label-service.herokuapp.com/api/image?${typeParam}capsules=${imagesArray.join(',')}&device=desktop`)
                $('.custom-image-url').val(`https://cadenceco-label-service.herokuapp.com/api/image?${typeParam}capsules=${imagesArray.join(',')}&device=desktop`)
                
                //TODO: REMOVE THE CHECK FOR DYNACAPSULE IF NOT NEEDED ANYMORE
                // image_service_dynacapsule = 'https://dynacapsule-529bc86c6a21.herokuapp.com'
                if (isDynaCapsuleBundle(productHandle)) {
                  $('.imageFromService').attr('src', `https://dynacapsule.com/labeled.php?product=${productHandle}&colors=${imagesArray.join(',')}`)
                  $('.custom-image-url').val(`https://dynacapsule.com/labeled.php?product=${productHandle}&colors=${imagesArray.join(',')}`)
                }
               
              }
              else {
                $(`.build-your-${bundleSize}-overlay-image.i${productIndex}`).removeClass('active');
                $(`.build-your-${bundleSize}-overlay-image.i${productIndex}.c${index + 1}`).addClass('active');
              }
            }
          }
          
          if (select.data('type') === labelType && value) {
            const labelParent = this.$input.closest('.label-block ');
            $('[data-selected-label]').html(`Label: ${value}`);
            labelParent.data('prev-value', value)
          }

          // ============ DYNACAPSULE IMAGE URL FOR PROPETIES
          let url_product_handle = $(".page-content").attr('data-product-handle');
          if(isBuildBundle && isDynaCapsuleBundle(url_product_handle)) {
            let dyna_url_labels = $('.premade-labels div.selectize-input > div.item').map((index, item) => {
                return $(item).data('value'); }).get().join(',');
            const pindex = select.data('product-index');
            let dyna_url_colors = $('.imageFromService').attr('data-boxes').split(',');
            dyna_url_colors[pindex - 1] = bundleColorValues.indexOf(selectedOption) + 1;
            let dynamic_url_with_labels = `https://dynacapsule.com/labeled.php?product=${url_product_handle}&colors=${dyna_url_colors.join(',')}&labels=${encodeURIComponent(dyna_url_labels)}`;
            $('.custom-image-url-labeled').val(dynamic_url_with_labels);
             // CUSTOMCAPSULESUMMARY -- go through each capsule and extract
            // color, size, and label
            let labels = $('.premade-labels select').map((index, elem) => {
              const label = $(elem).closest('.label-block').find('.premade-labels .item').attr('data-value') || ''
              return {label}
            })

            let colors = $('.color-dropdown select').map((index, elem) => {
              const color = $(elem).closest('.label-block').find('.color-dropdown .item').attr('data-value') || $('.color-options .variant-input.active input').val() || ''
              return {color}
            })
            //now consolidate the labels and colors into a single string for the custom image url
            // Color (Label)##Color (Label)##Color (Label) ... etc
            let descriptive_summary = '';
            let capsule_size = '';
            if(labels.length > 0 && colors.length > 0) {
              for (let i = 0; i < labels.length; i++) {
                descriptive_summary += `${capsule_size} ${colors[i].color} (${labels[i].label})`;
                if (i < labels.length - 1) {
                  descriptive_summary += '##';
                }
              }
            }
            $('.capsule-cart-summary').val(descriptive_summary);
            
            //check if item is defined
            //KLAVIYO TRACKING FOR EVENTS
            if (typeof item !== 'undefined') {
              item.ImageURL = dynamic_url_with_labels;
              var _learnq = _learnq || []; 
              _learnq.push(['track', 'Viewed Product', item]);
              _learnq.push(['trackViewedItem', {
                Title: item.Name || '',
                ItemId: item.ProductID || '',
                Categories: item.Categories || [],
                ImageUrl: item.ImageURL || '',
                Url: item.URL || '',
                Metadata: {
                  Brand: item.Brand || '',
                  Price: item.Price || 0,
                  CompareAtPrice: item.CompareAtPrice || 0
                }
              }]);
            }
          }
          // ============ DYNACAPSULE IMAGE URL FOR PROPETIES

          const label = $(elem).closest('.label-block').find('.premade-labels .item').attr('data-value') || ''
          
          const color = $(elem).closest('.label-block').find('.color-dropdown .item').attr('data-value') || $('.color-options .variant-input.active input').val() || ''
          
          const cancelSelect = () => {
            const selectize = this
            $(elem).closest('.label-block').data('prev-value', '')
            
            selectize.clear()
            selectize.setValue("");
          }
          
          if (window.outOfStockAraki[color] && 
            label.length > 0 && 
            window.outOfStockAraki[color].includes(label)
          ) {
            cancelSelect()
            callPreOrderModal(
              $(this).data('product-name'),
              $(this).data('product-id'),
              $(this).data('variant-name'),
              $(this).data('variant-id'),
              'araki-'
            );
          }
          if (isCustomImage(value) && isValidMOQ && !isValidMOQ().label) {
            cancelSelect()
            $('.js-modal-open-moq-error').click()
          }
          if (window.addBaSLabel) {
            addBaSLabel(value, this.$input)
            cancelSelect()
            return
          }

          _updateLabels(this.$input);
        },
        render: {
          option: function (data, escape) {
            let additionalClass = (() => {
              if (data.value === 'label_free') return ' custom-selectize-label'
              if (data.value.includes('Custom Logo')) return ' custom-logo-label'
              return ''
            })();
            if (data.disabled) additionalClass += ' disabled';
            let div1 = `<div class="option${additionalClass} ${data.is_author ? 'is_author' : ''}"  data-selectable="" data-customize="${data.customize}" data-value="${data.value}">`;
            if (data.value === 'label_araki') {
              return `${div1}<span>${data.text}</span><span class="arrow ico-chevron-down"></span></div>`
            }
            if (data.type === colorType) {
              div1 =`<div style="display: flex; align-items: center" class="option${additionalClass} color${data.value}" data-product-id="${data.productId}" data-product-name="${data.productName}" data-variant-id="${data.variantId}" data-variant-name="${data.variantName}"  data-selectable="" data-customize="${data.customize}" data-value="${data.value}">`;
            }
            if (isIcon(data.value)) {
              return `${div1}<img src="${data.url}1" style="width: 1.5rem;"></div>`;
            }
            if (isGoldenHour(data.value)) {
              return `${div1}<span class="color-option color-swatch--${data.value.toLowerCase()}"></span>${data.value}</div>`;
            }
            if (data.type === colorType) {
              return `${div1}<span class="color-option ${data.value}"></span>${data.value}</div>`;
            }
            if (data.type === giftCardAmountType) {
              return `<div class="option" data-cost="${data.cost}" data-id="${data.id}" value="${data.value}"> ${data.value} </div>`;
            }
            return `${div1}${data.text}</div>`;
          },
          item: function (data, escape) {
            let div1 = `<div class="item ${escape(data.className)}" data-labelmessage="${data.text}" data-value="${data.value}">`;
            if (data.type === colorType) {
              div1 = `<div style="display: inline-flex; align-items: center" class="item" data-labelmessage="${data.text}" data-value="${data.value}">`;
            }
            if (isIcon(data.value)) {
              return `${div1}<img src="${data.url}1" style="width: 1.5rem;"></div>`;
            }
            if (data.type === colorType) {
              return `${div1}<span class="color-option ${data.value} _${data.value}"></span>${data.value}</div>`;
            }
            if (data.type === giftCardAmountType) {
              return `<div data-cost="${data.cost}" data-id="${data.id}" value="${data.value}"> ${data.value} </div>`;
            }
            return `${div1}${data.value}</div>`;
          },
          ...selectizeHelper.render
        },
        onItemAdd: function (value, $item) {
          $item.addClass('selected');
          this.settings.setPlaceholder(this)
        },
        onItemRemove: function(value){
          const $selectedItemsList = $('.selected-items-list');
          const $selectedItem = $selectedItemsList.find(`.selected-item[data-value="${value}"]`);
          if ($selectedItem.hasClass(starterLabelSelectizeUserCreatedTagClass)) {
            this.removeOption(value)
            this.$dropdown.find(`[data-value="${value}"]`).remove()
          }
          this.$control_input.prop('readonly', true)
          this.settings.setPlaceholder(this)
        },
        createFilter: function(input) {
          const regexp = new RegExp('^' + input, 'i');
          return (item) => regexp.test(item.text);
        },
        onFocus: function() {
          if (this.$input.data('type') !== labelType) {
            const input = 'selectize-input input', wrapper = 'selectize-input';
            $(`.${input}`).attr('readonly', true);
            $(`.${input}, .${wrapper}`).css('cursor', 'pointer');
          }
        },
        onDropdownOpen: function() {
          if (this.$input.data('type') === labelType) {
            this.clear()
            this.$control_input
              .focus()
              .blur()
              .prop('readonly', true)
              .on('mousedown', function() {
                $(this).prop('readonly', false);
              })
              .on('input', function() {
                // EMOJIMOVIE
                this.value = this.value.replace(/[\uD800-\uDFFF]./g, '');
              })
              .attr('maxlength', maxCustomLabelLength);
            $('.selectize-dropdown').addClass('open')
            this.settings.setPlaceholder(this)
          }
        },
        onDropdownClose: function() {
          this.settings.setPlaceholder(this)
        },
        setPlaceholder: function(self) {
          const dropDownIsOpen = self.$dropdown.is(":visible")
          const placeholder = dropDownIsOpen ? placeholderOnLebelSelectizeOpen : self.settings.placeholder
    
          self.$control_input.attr('placeholder', placeholder);
        },
        onBlur: function() {
          const labelParent = this.$input.closest('.label-block ');
          const value = labelParent.data('prev-value')
          if(this.$input.data('type') === labelType && !this.items.length && value) {
            const valueToSet = this.search(value).items[0].id
            this.setValue(valueToSet)
          }
          this.settings.setPlaceholder(this) 
          $('.selectize-dropdown').removeClass('open')
        }
      }
      window.initializeLabelsObject = initializeLabelsObject
    $('select[data-build-selectize]').each(function () {
      const $this = $(this);
      const isColorOption = $this.data('type') === 'color-option'
      if (isColorOption) handleColor();
  
      const plugins = ['araki-icons'];
      if (isColorOption) plugins.push('preorder')
  
      var $select = $(this).selectize({...initializeLabelsObject, plugins});
  
      function handleColor() {
        const selectedOption = $this.find('option:selected').val();
        const productIndex = $this.data('product-index');
        const values = Array.from($this[0].options).map(o => o.value);
        const index = values.indexOf(selectedOption);
        const colorIdx = colorNames.indexOf(selectedOption.trim());
        const color = labelColors[colorIdx];
  
        // label img
        $(`.hex-container-${productIndex}`).find('.product-label-image').removeClass('active');
        
        // LABELPREVIEW-UPDATES
        $($(`.hex-container-${productIndex}`).find(`.product-label-image.${selectedOption}`)).addClass('active');
        //replaces this -->
        // $($(`.hex-container-${productIndex}`).find('.product-label-image')[colorIdx]).addClass('active');
        
        // label text color
        $(`.hex-container-${productIndex}`).find('.hex-graphics text').css('fill', color);
        // bundle overlay capsules
        if (isBuildBundle) {
          $(`.build-your-${bundleSize}-overlay-image.i${productIndex}`).removeClass('active');
          $(`.build-your-${bundleSize}-overlay-image.i${productIndex}.c${index + 1}`).addClass('active');
        }
  
        _updateLabels();
      }
    });
  
    // Custom label text input
    $('.close-custom-label').click(function (e) {
      e.preventDefault();
      var labelParent = $(this).closest('.label-block ');
      labelParent.find('.premade-labels .selectize-input input').removeAttr('style');
      labelParent.find('.custom-label').val('');
      labelParent.find('.premade-labels').show();
      labelParent.find('.custom-label-container').hide();
      labelParent.find('.custom-label-image-container').hide();
  
      initializeCustomLabelsObject = {
        plugins: ['restore_on_backspace'],
        delimiter: ',',
        persist: false,
        create: false,
        form: 'test',
        sortField: [{
          field: 'value',
          direction: 'asc'
        }],
        onChange: function (value) {
          var elem = this.$input[0];
          getPremadeLabel(elem);
        },
        render: {
          option: function (data, escape) {
            return '<div class="option"  data-selectable="" data-customize="' + data.customize + '" data-value="' + data.value + '">' + data.text + '</div>'
          },
          item: function (data, escape) {
            return '<div class="item" data-value="' + data.value + '">' + data.value + '</div>'
          }
        },
        onItemAdd: function (value, $item) {
          var data = this.options[value];
        }
      }
      window.initializeCustomLabelsObject = initializeCustomLabelsObject
      var $select = labelParent.find('.premade-labels select').selectize(initializeCustomLabelsObject);
      var control = $select[0].selectize;
      control.clear();
  
    });
  
  
  // CUSTOM LABELS
  
    $(document).on('change', '.premade-labels .selectized' ,function () {
      const labelParent = $(this).closest('.label-block ');
      const customizeCheckBox = labelParent.find('.selectized[data-type="label-value"] option').val();
  
      labelParent.find('.custom-label-container').hide();
      labelParent.find('.custom-label').val('');
      labelParent.find('.custom-label-value').val('');
      labelParent.find('.custom-label-image-container').toggle(!!isCustomImage(customizeCheckBox))
    });
  
    // INPUT CHECKING
  
    function clearPremadeLabel(input) {
      var labelDest = $(input).data('location');
      var label = $(input).val();
      var hex = $(input).closest('.label-container').data('hex');
      var selector = $('#' + hex + ' text.' + labelDest + '');
      $(selector).text('');
    }
    // Custom code
    // CHECKOUTEXTENSIBILITY
    function _updateLabels(target) {
      let elem = null;
      if(isBuildBundle || isCorporateGifting) {
        for (let i = 1; i <= bundleSize; i++) {
          elem = $(`.premade-labels select[name="properties[_Standard Bundle Label ${i}]"]`);
          _updateLabel(elem);
        }
      } else {
        elem = $('.premade-labels select[name="properties[_Label]"]');
        if (isBaS && target)
          elem = $(target).closest('.label-block').find('.premade-labels select[name="properties[_Label]"]');
        if (elem.length > 0) _updateLabel(elem);
      }
      resetGallery();
    }
    function _updateLabel(elem) {
      const selectedOption = elem.find('option:selected').val();
      let selectValue = null;

      getPremadeLabel(elem);
      if(!isCustomize(elem) && !isArakiIcon(selectedOption) || isArakiIcon(selectedOption) || isBaS) {
        selectValue = 'standard';
      } else {
        selectValue = 'custom';
      }
      if (isArakiIcon(selectedOption)) {
        selectValue = 'custom';
      }
      $('.main-variant-select').eq(0).val(isBuildBundle? calcBundleVariant() : selectValue).change();    
    }
  
    function resetGallery() {
      if(!window.mainGallerySwiper || window.mainGallerySwiper.destroyed) return;
  
      window.mainGallerySwiper.slideTo(0);
    }
  
  
    function getLabelColor(elem) {
      // Get active color index and label color
      let color = labelColors[0];
      if (isBuildBundle || isCorporateGifting){
        const labelBlock = elem.closest('.label-block.single-type');
        let selectedColor = labelBlock
          .find('select[data-type="color-option"]')
          .find('option:selected')
          .val();
        if (!selectedColor) {
          const index = labelBlock.closest('.label-wrapper').index()
          selectedColor = $('.color-wrapper').eq(index)
            .find('select[data-type="color-option"]')
            .find('option:selected')
            .val();
        }
        color = labelColorsByColor[selectedColor];
      } else {
        const colorLabel = $('.color-options label.color-swatch.active');
        const selectedColor = colorLabel.text().trim();
        color = labelColorsByColor[selectedColor];
      }
      if (isBaS) {
        const selectedColor = $('.current-item .variant-input-wrap input:checked').val() || $('.select-starter-color .color-options input:checked').val()
        color = labelColorsByColor[selectedColor];
      }
      return color;
    }
  
    function getPremadeLabel(input) {
      var labelDest = $(input).data('location');
      var label = $(input).val()?.trim();
      var hex = $(input).closest('.label-container').data('hex');
      var selector = $(`#${hex} text.${labelDest}`);
      if (isBaS)
        selector = $(input).closest('.label-block').find(`#${hex} text.${labelDest}`);
      var color = getLabelColor(input) || 'black';
      // Reset canvas
      $(`#${hex} image`).attr('opacity','0.0');
      $(selector).html('');
  
      // Render text or icon
      const opacity = isArakiIcon(label) ? "1" : "0.5"
      let findHexIn = $(document) 
      if (isBaS)
        findHexIn = $(input).closest('.label-block')
      
      if (isIcon(label)) findHexIn.find(`#${hex} image#${label}-${color}`).attr('opacity',opacity);
      else $(selector).html(parseLabel(label));
  
      setMainImgLabels(input, label);
    }
  
    function getCustomLabel(input, val) {
      var labelDest = $(input).data('location');
      var label = val || $(input).val();
      var hex = $(input).closest('.custom-label-container').data('hex');
      var selector = $('#' + hex + ' text.' + labelDest + '');
  
      // Reset canvas
      $(`#${hex} image`).attr('opacity','0.0');
      $(selector).html('');
  
      // Render text
      $(selector).html(parseLabel(label));
      setMainImgLabels($(input), label);
    }
  
    // Update main gallery preview
    function setMainImgLabels(elem, label) {
      if (!isBuildBundle && !isLabel && !isBaS) return;
  
      var color = getLabelColor(elem);
      let spanSelector = $(`.extra-label-labels-main > span.label`)
      if(isBuildBundle) {
        const curBlock = $(elem).closest('.label-block');
        let index = $('.label-block').index(curBlock) + 1;
        index = index > bundleSize ? index - bundleSize : index
        if (isCorporateGifting) {
          const capsules = Number($('.corporate-gifting-labels-preview').attr('data-capsules'))
  
          if (capsules === 2)
            index += 1
          if (capsules === 4 && index > 3)
            index += 1
          if (capsules === 5) {
            index += 1
          }
        }
  
        const labelsMainSelector = isCorporateGifting ? '.corporate-gifting-labels-preview' : `.build-your-${bundleSize}-labels-main`
        spanSelector= `${labelsMainSelector} > span.label-${index}`;
      }
      const span = $(spanSelector)
  
      if (isIcon(label)) {
        span.html('');
        const img = $($(`div.option[data-value="${label}"] > img`)[0]).clone();
        const imgSrc = img.attr('src');
        img.attr('src', imgSrc.replace('-black.svg',`-${color}.svg?`));
        img.attr('id', label);
        if (isArakiIcon(label)) {
          img.addClass('araki');
          span.addClass('araki')
        } 
        img.appendTo(span);
      } else if (isCustomImage(label)) {
        const customImage = $(elem).closest('.label-wrapper').find('.custom-label-image').attr('data-url')
        if (!customImage) return 
        span.html(`<img src="${customImage}" class="customImage">`);
      } else {
        span.removeClass('araki')
        span.html(parseLabel(label));
        span.css('color', color);
      }
    }
  
    $('.custom-label').on('input', function () {
      // source: https://stackoverflow.com/a/45138005
      const emoticonsRegexp = /[\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}]/ug;
      const validatedValue = this.value.replace(emoticonsRegexp, "");
      $(this).val(validatedValue);
      const labelParent = $(this).closest('.label-block ');
      labelParent.data('custom-prev-value', validatedValue)
      getCustomLabel(this, validatedValue);
    });
  
    $('.custom-label').each(function () {
      getCustomLabel(this);
    });
  
    function calcBundleVariant() {
      const propertyId = "UA-129403639-1";
      const customLabelsCount = $('.premade-labels div.selectize-input > div.item').filter((index, item) => {
        return isCustomize(item);
      }).length;
      let suffix = '';

      // RECYCLINTIME
      const customColorCount = $('.color-dropdown div.selectize-input > div.item').filter((index, item) => {
        const dataValue = $(item).data('value');
        // console.log('checking the individual item for color', dataValue)
        return dataValue === 'Renew';
      }).length;

      // get the the color parcel if it exists in the page
      var active_special_parcel_count = 0;
      
      $('input[name^="properties[_color_parcel_"]').each(function() {
        //check if this option is enabled or disabled, or if it has the property disabled=disabled
        if($(this).is(':checked') && !($(this).is(':disabled')) && $(this).val() === 'Canvas'){
          active_special_parcel_count = active_special_parcel_count + 5;
        }
      });

      // Check if the alternative variant should be used when the experiment is running
      if ($('html').hasClass('page-the_originals_-_set_of_6') && window.google_optimize && window.gaData &&
          window.gaData[propertyId] && window.gaData[propertyId].experiments
  ) {
        const experimentId = Object.keys(window.gaData[propertyId].experiments)[0];
        const variationId = gaData[propertyId].experiments[experimentId];
        if (variationId && variationId == 1) suffix = '.';
      }

      var final_count = customLabelsCount + customColorCount + active_special_parcel_count;
      if(final_count > 14){
        final_count = 14;
      }

      //if this prpoduct handle is the-132-set-of-7
      if (
        window.location.pathname.includes('the-132-set-of-2') || 
        window.location.pathname.includes('the-132-set-of-3') || 
        window.location.pathname.includes('the-132-set-of-7') || 
        window.location.pathname.includes('the-132-set-of-7-2') ||
        window.location.pathname.includes('the-132-set-of-7-parcel') || 
        window.location.pathname.includes('the-132-set-of-7-fp')) {
        //use the new bundlesizes for the 7 capsules
        return `${bundleSize} Flex Capsules - ${final_count}CSTM`;
      }

      if (customLabelsCount === 0) return `${bundleSize} standard${suffix}`;
      if (customLabelsCount === bundleSize) return `${bundleSize} custom${suffix}`;
      return `${customLabelsCount} custom & ${bundleSize - customLabelsCount} standard${suffix}`;
    }
  
    $('[action="/cart/add"]').submit(function( event ) {
      _updateLabels()
    });

    //if there is a change in the properties[_color_parcel_], then recalculate the labels/update the labels
    $('input[name^="properties[_color_parcel_"]').change(function() {
      console.log('parcel change triggered as well, recalculate');
      //check if this option is enabled or disabled, or if it has the property disabled=disabled
      _updateLabels()
    });
  
    (function presetSettings() {
      const params = getUrlParams()
      
      $('.label-block').each((i, el) => {
        const colorSelect = $(el).find('.color-dropdown [data-build-selectize]').eq(0)
        const colorSelectize = colorSelect.data('selectize');
        color = params[`color${i}`]
        if (colorSelectize && color) {
          // colorSelectize.setValue(color);
          if (colorSelectize.options.hasOwnProperty(color)) {
            // If the color exists in the options, set the value
            colorSelectize.setValue(color);
          }else{
            console.log('preset option does not exist for color', color);
          }
        }

        const labelSelect = $(el).find('.premade-labels [data-build-selectize]').eq(0)
        const labelSelectize = labelSelect.data('selectize');
        label = params[`label${i}`]
        if (labelSelectize && label) {
          labelSelectize.setValue(label);
        }
  
        const customLabelInput = $(el).find('.custom-label').eq(0)
        customLabel = params[`customLabel${i}`]
        if (customLabelInput && customLabel) {
          customLabelInput.val(customLabel);
        }
      })
  
    }())
    
    // LANDINGPAGES2024
    // presets for labels go here, if they have specific URLs
    // this can be outsourced to a separate file if needed
  
    function getUrlParams() {

      //if this url contains honeycomb, return array of params
      const current_url = window.location.href;

      //to set the ab test: 
      // sessionStorage.setItem('ABT_singleslabels_aug25', 'preselect');
      // sessionStorage.setItem('ABT_singleslabels_aug25', 'default');
      if (
        !window.location.pathname.includes('set-of') &&
        (
          window.location.pathname.includes('the-vault-capsules') ||
          window.location.pathname.includes('the-132') ||
          window.location.pathname.includes('the-275') ||
          window.location.pathname.includes('the-capsule') ||
          window.location.pathname.includes('the-56')
      )){
        //check if they are part of the ab test
        // const label_ab_test_version = sessionStorage.getItem('ABT_singleslabels_aug25');
        // console.log('activating ab test for singles labels', label_ab_test_version);
        // if (label_ab_test_version === 'preselect') {
        //   return {
        //       label0: '*Blank Label*'
        //   }
        // }
        return {
            label0: '*Blank Label*'
        }
      }

      if (
        window.location.pathname.includes('the-132-set-of-6') ||
        window.location.pathname.includes('the-132-set-of-7-parcel') || 
        window.location.pathname.includes('the-132-set-of-7-fp')
    ) {
        return {
          label0: 'Shampoo',
          label1: 'Conditioner',
          label2: 'Body Wash',
          label3: 'Cleanser',
          label4: 'Moisturizer',
          label5: 'sun-icon',
          label6: '*Blank Label*',

          color0: 'Pearl',
          color1: 'Pearl',
          color2: 'Berry',
          color3: 'Granite',
          color4: 'Granite',
          color5: 'Berry',
          color6: 'Berry',

        }
      }


      if (window.location.pathname.includes('the-132-set-of-3')) {
        return {
          label0: 'Shampoo',
          label1: 'Conditioner',
          label2: 'Body Wash',
          color0: 'Mocha5PMClay',
          color1: 'SageMochaAlmond',
          color2: '5PMSageCacao',
        }
      }


      // SANTORINITIME
      if (window.location.pathname.includes('the-132-set-of-2')) {
        return {
          label0: 'Moisturizer',
          label1: 'Shampoo',
          color0: 'Sherbet',
          color1: 'Sherbet',
        }
      }


      // NEWBLUES
      // 1 Arctic, 1 Pacific, 1 Atlantic, 1 Santorini
      // if (window.location.pathname.includes('the-132-set-of-4')) {
      //   return {
      //     color0: 'Arctic',
      //     color1: 'Pacific',
      //     color2: 'Arctic',
      //     color3: 'Santorini'
      //   }
      // }
      
      // if the url has a parameter with the word "wave", preselect labels
      if (window.location.pathname == '/products/the-132' && window.location.search.includes('wave')) {
          return {
            label0: 'atlantic-icon',
            color0: 'Pacific',
          }
      }

      //run a simple AB test for the 132 set of 7
      if (
        current_url.includes('the-132-set-of-7') ||
        current_url.includes('the-132-set-of-5')
        ) {
        // console.log('running ab test on by7');
        // const preselect_status = Math.random() >= 0.5;
        // console.log(preselect_status);
        // $.post('/cart/update.js', {
        //   attributes: { 
        //     preselect_labels: preselect_status
        //   }
        // });

        // console.log('showing the global variable');
        // console.log(this_is_a_global_variable);
        // console.log('grabbing stuff from session storage: ',sessionStorage.getItem('ab_session_group'));

        const ab_test_version = sessionStorage.getItem('ABT_by7labels_jan24');
        //VERSIONS preselect or control
        // if (preselect_status) {
          return {
            label0: 'Shampoo',
            label1: 'Conditioner',
            label2: 'Body Wash',
            label3: 'Cleanser',
            label4: 'Moisturizer',
            label5: 'sun-icon',
            label6: '*Blank Label*',

            color0: 'Petal',
            color1: 'Blush',
            color2: 'Sand',
            color3: 'Eucalyptus',
            color4: 'Petal',
            color5: 'Mocha',
            color6: 'BlushTerra'
          }
        // }
      }

      if (current_url.includes('build-your-6')) {
          return {
            label0: 'Shampoo',
            label1: 'Conditioner',
            label2: 'Body Wash',
            label3: 'Cleanser',
            label4: 'Moisturizer',
            label5: 'sun-icon',

            color0: 'Eucalyptus',
            color1: '5PM',
            color2: '6PM',
            color3: 'Sage',
            color4: 'Terracotta',
            color5: 'Sage',
          }
      }

      if (current_url.includes('original-12')) {
        // Charcoal,Mocha,Atlantic,Pine,Terracotta,Eucalyptus,5PM,Petal
        return {
          label0: 'Shampoo',
          label1: 'Conditioner',
          label2: 'Body Wash',
          label3: 'Cleanser',
          label4: 'Moisturizer',
          label5: 'sun-icon',
          label6: 'rainbow-icon',
          label7: 'heart-icon',

          // terra,arctic,5pm,pine,petal,cacao,sage,arctic,petal,euca,terra,5pm 

          color0: 'Terracotta',
          color1: 'Petal',
          color2: '5PM',
          color3: 'Pine',
          color4: 'Eucalyptus',
          color5: 'Terracotta',
          color6: 'Petal',
          color7: '5PM',
          color8: 'Pine',
          color9: 'Eucalyptus',
          color10: 'Terracotta',
          color11: 'Petal' 
        }
    }

      if (!window.location.search) return {}
      const urlSearchParams = new URLSearchParams(window.location.search);
      return Object.fromEntries(urlSearchParams.entries());
    }
  
  })($);
}
initProductLabelsJS()

